import { useOpenDevbarOnCustomEvent } from '@dbh/development-bar';

const DevelopmentBarOpener=()=>(useOpenDevbarOnCustomEvent(),null);

export { DevelopmentBarOpener as default };
